<template>
  <article class="uk-comment uk-visible-toggle comment-item" :class="{ 'comment-item--nested': depth > 0 }" tabindex="-1">
    <header class="uk-comment-header uk-position-relative">
      <div class="uk-grid-medium uk-flex-middle uk-grid" uk-grid="">
        <div class="uk-width-auto uk-first-column">
          <UserProfileAvatar
            :name="[comment.user?.name, comment.user?.surname].filter(Boolean).join(' ')"
            :photo="comment.user?.photo_link"
            class="comment-avatar"
          />
        </div>
        <div class="uk-width-expand">
          <h6 class="h6 mt-0 mb-0">
            {{ comment.user.name + " " + comment.user.surname }}
          </h6>
          <p class="uk-text-meta uk-margin-remove-top">
            <time datetime="2016-04-01T19:00">@{{
              comment.user.name.toLowerCase() +
              "." +
              comment.user.surname.toLowerCase()
            }}</time>
          </p>
        </div>
        <div class="uk-width-auto">
          <div class="text-muted h7 mb-2 comment-time">
            <i class="uil-clock"></i>{{ timeFromNow(comment.created_at) }}
          </div>
        </div>
      </div>
    </header>
    <div class="uk-comment-body mb-2">
      <p>{{ comment.text }}</p>
      <p class="mb-3 ml-2" v-if="comment.status_id === 1">
        <strong>({{$t('general.sent_to_admin_approval')}})</strong>
      </p>
    </div>
    <div class="comment-actions">
      <button type="button" @click="openCommentArea" class="comment-action">
        <i class="uil-comment"></i>
        {{ $t("general.answer") }}
      </button>
      <button
        v-if="hasReplies"
        type="button"
        @click="toggleReplies"
        class="comment-action comment-action--toggle">
        <i class="uil-angle-down" :class="{ 'reply-chevron-open': showReplies }"></i>
        {{ showReplies ? ($t("general.hide_replies")) : ($t("general.show_replies")) }}
      </button>
      <button
        v-if="comment.user_id == current_user.id"
        type="button"
        @click="deleteComment"
        class="comment-action is-delete"
      >
        <i class="uil-trash-alt"></i>
      </button>
    </div>
    <div
      :class="'inner_comment_' + comment.id"
      class="form-group comment_section text-right mb-0 reply-box"
      v-show="showReply"
    >
      <div class="reply-box-inner">
        <textarea
          ref="replyTextarea"
          class="reply-textarea"
          rows="2"
          v-model="form.comment"
          :placeholder="$t('general.what_are_you_thinking')"
        ></textarea>
        <div class="reply-actions">
          <button type="button" v-if="form.comment.length" @click="replyComment(true)" class="btn btn-sm btn-primary">
            {{ $t("general.save") }}
          </button>
        </div>
      </div>
    </div>

    <ul v-if="showReplies && directReplies.length > 0" class="comment_tree_view nested_comments pt-3 reply-thread">
      <li v-for="(reply, index) in directReplies" :key="'comment_item_' + reply.id + '_' + index">
        <CommentItem
          @reset="resetForm()"
          :current_user="current_user"
          :post_id="post_id"
          :post_index="post_index"
          :depth="depth + 1"
          @reply="replyComment($event)"
          :comment="reply"
        ></CommentItem>
      </li>
    </ul>
  </article>
</template>

<script>
import moment from "moment";
import 'moment/locale/fr';
import 'moment/locale/es';
import 'moment/locale/az';
import 'moment/locale/tr';
import 'moment/locale/en-gb';
import CommentItem from "@/view/components/wall/Comment";
import UserProfileAvatar from "@/view/components/common/UserProfileAvatar.vue";
import { DELETE_ITEM_BY_ID } from "@/core/services/store/REST.module";
import store from "@/core/services/store";
import module from "@/core/services/store/comment.module";
import user_module from "@/core/services/store/user.module";

const MODULE_NAME = "COMMENT";
const USER_MODULE_NAME = "USER";

export default {
  name: "CommentItem",
  components: { CommentItem, UserProfileAvatar },
  props: {
    comment: {
      required: true,
    },
    depth: {
      type: Number,
      default: 0,
    },
    current_user: {
      required: true
    },
    post_id: {
      required: true,
    },
    post_index: {
      required: true,
    },
  },
  data() {
    return {
      form: {
        comment: "",
      },
      showReply: false,
      showReplies: false,
    };
  },
  computed: {
    directReplies() {
      return Array.isArray(this.comment?.approved_replies)
        ? this.comment.approved_replies
        : [];
    },
    hasReplies() {
      return this.directReplies.length > 0;
    },
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }
    registerStoreModule(MODULE_NAME, module);
    registerStoreModule(USER_MODULE_NAME, user_module);
  },
  methods: {
    toggleReplies() {
      this.showReplies = !this.showReplies;
    },
    deleteComment() {
      let id = this.comment.id

      let self = this;
      self.$store
        .dispatch(DELETE_ITEM_BY_ID, {
          url: `/api/comment/${id}`,
          acceptPromise: true,
        })
        .then((result) => {
          this.$emit('reset')
        });
    },
    resetForm() {
      this.$emit('reset')
    },
    replyComment(buttonClick) {
      let data = buttonClick
      if (data === true)
        data = {
          text: this.form.comment,
          index: this.post_index,
          id: this.post_id,
          comment_id: this.comment.id
        }

      this.$emit('reply', data)

      this.form.comment = "";
      this.showReply = false;
    },
    openCommentArea(eve) {
      this.showReply = !this.showReply;
      if (this.showReply) {
        this.$nextTick(() => {
          if (!this.form.comment) {
            const user = this.comment && this.comment.user ? this.comment.user : {};
            const first = user.name || "";
            const last = user.surname || "";
            const fullName = `${first} ${last}`.trim();
            if (fullName) {
              this.form.comment = `@${fullName} `;
            }
          }
          const textarea = this.$refs.replyTextarea;
          if (textarea) {
            textarea.focus();
          }
        });
      }
    },
    timeFromNow(date) {
      return moment(date).locale(this.secureLocalStorage("language")).format('DD MMMM YYYY')
    },
  },
};
</script>
<style>
.comment-item {
  margin: 0 0 10px;
  padding: 12px;
  border: 1px solid #e6e6e8;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(17, 24, 39, 0.05);
}

.comment-item--nested {
  border: none;
  background: #fbfcfe;
  box-shadow: none;
}

.comment-time {
  font-size: 12px;
  color: #6b7280;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.comment-avatar {
  width: 32px;
  height: 32px;
  min-width: 32px;
  flex-shrink: 0;
  font-size: 11px;
}

.comment-item--nested .comment-avatar {
  width: 28px;
  height: 28px;
  min-width: 28px;
  font-size: 10px;
}

.uk-comment-body {
  margin: 8px 0 0;
}

.comment-bubble,
.uk-comment-body {
  background: #f6f8fb;
  border: 1px solid #e8edf3;
  border-radius: 14px;
  padding: 10px 12px;
}

.uk-comment-body p {
  margin: 0;
  color: #1f2937;
  line-height: 1.5;
  font-size: 16px;
}

ul.comment_tree_view {
  list-style: none;
  margin: 0;
  padding-left: 0;
}

ul.comment_tree_view li {
  margin-top: 10px;
  margin-left: 0;
  padding-left: 0;
}

ul.comment_tree_view li > article {
  margin-top: 0;
}

.comment_tree_view > li {
  padding-left: 0;
  margin-left: 0;
}

.comment-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;  
}

.comment-action {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid transparent;
  background: #eef2f7;
  color: #374151;
  font-size: 14px;
  font-weight: 600;
  padding: 5px 10px;
  min-height: 48px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.18s ease;
  outline: none !important;
}

.comment-action:active {
  transform: scale(0.98);
  opacity: 0.9;
}

.comment-action:hover {
  background: #e6e8eb;
  color: #4b5563;
}

/* .comment-action--toggle {
  background: #f3f7fc;
  color: #0f4c81;
} */

.comment-action--toggle:hover {
  background: #e6e8eb;
  color: #4b5563;
}

.reply-chevron-open {
  transform: rotate(180deg);
}

.comment-action.is-delete {
  background: #fff1f2;
  color: #b42318;
}

.comment-action.is-delete:hover {
  background: #ffe4e6;
  color: #912018;
}

.comment_section {
  margin-top: 10px;
}

.reply-box {
  margin-top: 8px;
}

.reply-box-inner {
  background: #f8fafc;
  border: 1px solid #e8edf3;
  border-radius: 12px;
  padding: 10px;
}

.reply-textarea {
  width: 100%;
  border: 1px solid #d8dee8;
  border-radius: 10px;
  min-height: 48px;
  font-size: 16px;
  padding: 10px 12px;
  background: #ffffff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.reply-textarea:focus {
  border-color: #0a66c2;
  box-shadow: 0 0 0 3px rgba(10, 102, 194, 0.12);
  outline: none;
}

.reply-actions {
  margin-top: 8px;
  text-align: right;
}

.reply-actions .btn-primary {
  min-height: 48px;
  border-radius: 10px;
}

.reply-actions .btn-primary:active {
  transform: scale(0.98);
  opacity: 0.9;
}

.reply-thread {
  margin-top: 10px;
  margin-left: 8px;
  padding-left: 0;
  border-left: none;
}

.reply-thread > li:first-child {
  margin-top: 0;
}

@media (max-width: 640px) {
  .comment-item {
    padding: 12px;
  }

  .comment-action {
    min-height: 48px;
  }

  .reply-thread {
    margin-left: 4px;
    padding-left: 0;
  }
}

@media (hover: none) {
  .comment-action:hover,
  .comment-action--toggle:hover,
  .comment-action.is-delete:hover {
    background: inherit;
    color: inherit;
  }
}
</style>
